import { useAuthStore } from '@/stores/auth'
import { showAlert } from '@/composables/useAlert'

// Middleware to protect routes that require authentication
export function authMiddleware(to, from, next) {
  const authStore = useAuthStore()

  if (to.meta.requiresAuth) {
    if (!authStore.isLoggedIn) {
      // message to show if user is not logged in 
      showAlert('سجل أولاً للمتابعة', 'error')
      next('/login')
    } else {
      next()
    }
  } else {
    next()
  }
}


